import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../hooks/useAppSelector';
import { configSelector } from '../../redux/ConfigState/ConfigState.selectors';
import { mopOnFileSelector } from '../../redux/MopOnFileState/MopOnFileState.selectors';
import { paymentSelector } from '../../redux/PaymentState/PaymentState.selectors';
import { appModeSelector } from '../../redux/AppModeState/AppModeState.selectors';
import CreditCardForm from './CreditCardForm';
import { PaymentButtons } from './PaymentButtons';
import { MopActionWrapper, LinkWrapper, LinkWithDisabledStyle } from '../PaymentForm/styled';
import { DataTestAttributes } from '../../constants/DataTestAttributes';
import { getPaymentFieldLabelText, hasFormFieldErrors, setInitialState } from '../PaymentForm/helpers';
import { PaymentFormDataFields } from '../UserAddress/constants';
import { getString } from '../../constants/Strings';
import { PaymentMethods } from '../../constants/PaymentTypes';
import { Button } from '@chegg-ui/button';
import { setAppMode } from '../../redux/AppModeState/AppModeState.actions';
import { saveConfigs } from '../../redux/ConfigState/ConfigState.actions';
import { SubType, ElementType, SharedCommandNames, PaymentMethodsCommandNames, StatusTypes, SpecType, sendRioEvent } from '@chegg/commerce-utils';
import { doFireStatusUpdate, sendRioEventCallback } from '../../utils/CallbackUtils';
import { ERRORS } from '../../constants/Errors';
import { updatePaymentState } from '../../redux/PaymentState/PaymentState.actions';
import { sendNewRelicMessage } from '../../utils/NewRelicUtils';
import { Component } from '../../constants/CallbackConstants';
import { CheckboxWrapper } from './styled';
export var PaymentForm = function PaymentForm() {
  var config = useAppSelector(configSelector);
  var payment = useAppSelector(paymentSelector);
  var mopOnFile = useAppSelector(mopOnFileSelector);
  var appMode = useAppSelector(appModeSelector);
  var submit = config.submit,
    mopCreated = config.mopCreated,
    ui = config.ui,
    supportedPaymentMethods = config.supportedPaymentMethods,
    priceSummary = config.priceSummary,
    rioNamespace = config.rioNamespace,
    paymentForm = config.paymentForm;
  var _ref = ui,
    showSubmitButton = _ref.showSubmitButton;
  var formFields = payment.formFields,
    isLoading = payment.isLoading;
  var paymentMethods = mopOnFile.paymentMethods;
  var goBackMode = appMode.goBackMode;
  var isInitializing = false; // @TODO: remove static value once this is ready
  var hasFormErrors = hasFormFieldErrors(formFields);
  var hasMops = !!(paymentMethods.length > 0);
  var dispatch = useDispatch();
  var _useState = useState(setInitialState(isLoading, false)),
    _useState2 = _slicedToArray(_useState, 2),
    isDisabled = _useState2[0],
    setIsDisabled = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isCheckboxChecked = _useState4[0],
    setIsCheckboxChecked = _useState4[1];
  useEffect(function () {
    if (mopCreated) {
      dispatch(saveConfigs({
        mopCreated: false
      }));
    }
    // If there are form errors, Add card CTA is re-enabled
    if (hasFormErrors) {
      setIsDisabled(false);
    }
  }, [submit, mopCreated, hasFormErrors]);
  useEffect(function () {
    if (!isDisabled && (hasMops || showSubmitButton)) {
      sendRioEvent({
        info: getString("APP.RIO.EVENTS.EL_NAME.".concat('ADD', "_CARD_ACTIVATED")),
        specType: SpecType.COMPONENT_VIEW,
        subType: SubType.COMPONENT,
        callback: sendRioEventCallback,
        namespace: rioNamespace,
        force: false
      });
    }
  }, [isDisabled]);
  useEffect(function () {
    sendRioEvent({
      info: getString('APP.RIO.EVENTS.EL_NAME.ADD_PM_LOADED'),
      specType: SpecType.COMPONENT_VIEW,
      subType: SubType.COMPONENT,
      callback: sendRioEventCallback,
      namespace: rioNamespace,
      force: false
    });
    sendRioEvent({
      info: getString('APP.RIO.EVENTS.EL_NAME.ADD_CARD_SHOWN'),
      specType: SpecType.COMPONENT_VIEW,
      subType: SubType.COMPONENT,
      callback: sendRioEventCallback,
      namespace: rioNamespace,
      force: false
    });
  }, []);
  useEffect(function () {
    setIsDisabled(isLoading);
    if (!isLoading && !hasMops) {
      doFireStatusUpdate([{
        status: StatusTypes.SUCCESS,
        command: PaymentMethodsCommandNames.PAYMENT_FORM_INITIALIZED,
        payload: {
          component: Component.PAYMENT_FORM
        }
      }]);
    }
  }, [isLoading]);
  useEffect(function () {
    if ((supportedPaymentMethods === null || supportedPaymentMethods === void 0 ? void 0 : supportedPaymentMethods.length) === 0) {
      var _ERRORS$NO_SUPPORTED_ = ERRORS.NO_SUPPORTED_PAYMENT_METHODS,
        message = _ERRORS$NO_SUPPORTED_.message,
        code = _ERRORS$NO_SUPPORTED_.code;
      dispatch(updatePaymentState({
        message: {
          text: message,
          type: StatusTypes.ERROR,
          code: code
        }
      }));
      doFireStatusUpdate([{
        status: StatusTypes.ERROR,
        command: SharedCommandNames.INITIALIZE,
        payload: {
          component: Component.PAYMENT_FORM,
          errors: [ERRORS.NO_SUPPORTED_PAYMENT_METHODS]
        }
      }]);
      sendNewRelicMessage('User has no supported methods of payment on checkout', {
        errors: JSON.stringify({
          priceSummary: priceSummary
        })
      });
    }
  }, [supportedPaymentMethods]);
  function onFormSubmit(_x) {
    return _onFormSubmit.apply(this, arguments);
  }
  function _onFormSubmit() {
    _onFormSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            event.preventDefault();
            // disable Add Card CTA when loading, tokenizing, and adding
            setIsDisabled(true);
            sendRioEvent({
              info: getString('APP.RIO.EVENTS.EL_NAME.CARD_CTA_CLICKED_ADD'),
              specType: SpecType.INTERACTION,
              subType: SubType.CLICK,
              elementType: ElementType.BUTTON,
              callback: sendRioEventCallback,
              namespace: rioNamespace
            });
            dispatch(saveConfigs({
              submit: true,
              isPrimary: isCheckboxChecked
            }));
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _onFormSubmit.apply(this, arguments);
  }
  var onCancelClick = function onCancelClick(e) {
    e.preventDefault();
    sendRioEvent({
      info: getString("APP.RIO.EVENTS.EL_NAME.CANCEL_PAYMENT_METHOD_CLICKED_".concat('NEW')),
      specType: SpecType.INTERACTION,
      subType: SubType.CLICK,
      elementType: ElementType.BUTTON,
      callback: sendRioEventCallback,
      namespace: rioNamespace
    });
    dispatch(setAppMode({
      mode: goBackMode,
      goBackMode: goBackMode
    }));
  };
  var onCheckboxClick = function onCheckboxClick(e) {
    setIsCheckboxChecked(e.target.checked); // Toggle the checked state
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PaymentButtons, null), (supportedPaymentMethods === null || supportedPaymentMethods === void 0 ? void 0 : supportedPaymentMethods.includes(PaymentMethods.CREDITCARD)) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CreditCardForm, null), /*#__PURE__*/React.createElement(CheckboxWrapper, {
    type: "checkbox",
    disabled: !hasMops // Disable checkbox for new user with no MOP only
    ,
    checked: isCheckboxChecked,
    onChange: onCheckboxClick,
    inputId: 'default-payment-method--checkbox',
    "data-test": DataTestAttributes.ADD_MOP_MAKE_DEFAULT_CHECKBOX
  }, getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.MAKE_DEFAULT_CHECKBOX_LABEL) || getString('APP.FORM.MAKE_DEFAULT')), (hasMops || showSubmitButton) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MopActionWrapper, null, hasMops && /*#__PURE__*/React.createElement(LinkWrapper, null, /*#__PURE__*/React.createElement(LinkWithDisabledStyle, {
    "data-test": DataTestAttributes.ADD_CARD_CANCEL_BUTTON,
    hasButtonBehavior: true,
    onClick: onCancelClick,
    href: '#' //@TODO: add conditional rendering once isInitializing is updated
    ,
    role: 'button',
    "aria-disabled": isInitializing,
    disabled: isInitializing,
    className: 'payment-form-cancel-button'
  }, getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.CANCEL) || getString('APP.MOPONFILE.CANCEL'))), /*#__PURE__*/React.createElement(Button, {
    onClick: onFormSubmit,
    disabled: isDisabled,
    "data-test": DataTestAttributes.CC_FORM_SUBMIT_BUTTON,
    disableHoverAnimation: true
  }, /*#__PURE__*/React.createElement("span", null, getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.ADD_CARD) || getString("APP.FORM.BUTTON.ADD")))))));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/Recurly/PaymentForm.js
// module id = 4618
// module chunks = 11